// @flow

import React from 'react';
import type { Node } from 'react';
import { breakpointsToArray } from '../../../helpers';
import { Flex } from '../../grid';

type Props = {|
  flexWrap?: boolean | [string, string, string, string, string],
  alignItems?: string | Array<string>,
  flexGrow?: string,
  flexBasis?: string,
  children?: Node,
|};

const FlexLabel = (props: Props) => (
  <Flex
    {...props}
  />
);

FlexLabel.defaultProps = {
  flexWrap: breakpointsToArray({ default: 'wrap', sm: 'nowrap' }),
  alignItems: 'center',
  flexGrow: '1',
  flexBasis: '100%',
  children: null,
};

export default FlexLabel;
